export default {
    zh: {
        contact: {
            title: '联系我们',
            description: '如果您有任何问题或需求，欢迎通过以下表单联系我们，我们将尽快回复您。',
            nameLabel: '您的姓名',
            namePlaceholder: '请输入您的姓名',
            emailLabel: '您的邮箱',
            emailPlaceholder: '请输入您的邮箱',
            phoneLabel: '您的电话',
            phonePlaceholder: '请输入您的电话号码',
            subjectLabel: '主题',
            subjectPlaceholder: '请选择咨询主题',
            subjectOptions: {
                product: '产品咨询',
                techSupport: '技术支持',
                cooperation: '合作洽谈',
                complaint: '投诉建议',
                other: '其他'
            },
            messageLabel: '您的留言',
            messagePlaceholder: '请详细描述您的需求或问题，我们会尽快回复您',
            submitButton: '提交留言',
            dialogConfirm: '确定'
        },
        validation: {
            nameRequired: '请输入您的姓名',
            nameLength: '姓名长度应在 2 到 20 个字符之间',
            emailRequired: '请输入您的邮箱',
            emailInvalid: '请输入正确的邮箱格式',
            phoneRequired: '请输入您的电话号码',
            phoneInvalid: '请输入正确的手机号码格式',
            subjectRequired: '请选择咨询主题',
            messageRequired: '请输入您的留言内容',
            messageLength: '留言内容应在 10 到 500 个字符之间'
        },
        dialog: {
            successTitle: '提交成功',
            successMessage: '感谢您的留言，我们将尽快与您联系！',
            failTitle: '提交失败',
            failMessage: '很抱歉，提交失败，请稍后再试或直接联系我们。'
        },
        navbar: {
            companyName: '祥和泰数码科技有限公司',
            home: '首页',
            about: '关于我们',
            aboutCompany: '公司简介',
            aboutHistory: '发展历程',
            aboutTeam: '管理团队',
            aboutOrg: '组织架构',
            news: '企业动态',
            newsInfo: '新闻资讯',
            boxs: '业务领域',
            boxsOverview: '业务概览',
            boxsServices: '主营业务',
            boxsProjects: '典型项目',
            recruits: '人才招聘',
            touch: '联系我们',
            login: '管理入口',
            searchPlaceholder: '搜索',
            language: '语言',
            languageNames: {
                zh: '中文',
                en: 'English',
                ja: '日本語',
                ko: '한국어',
            }
        },
        home: {
            slides: [
                {
                    title: '让更多人过上更有品质的生活',
                    subtitle: '开拓新价值',
                    button: '了解更多',
                    buttonLink: '/about',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: '以创新技术赋能企业数字化转型',
                    subtitle: '技术引领发展',
                    button: '我们的业务',
                    buttonLink: '/boxs',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: '构建可持续发展的数字化未来',
                    subtitle: '共创美好未来',
                    button: '加入我们',
                    buttonLink: '/recruits',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                }
            ],
            statistics: {
                clientCount: "客户数",
                projectCount: "项目数",
                teamCount: "团队人数",
                satisfaction: "客户满意度"
            },
            business: [
                {
                    title: '电子胶带系列',
                    desc: '黑色单,双面胶带。透明单,双面胶带',
                    icon: 'el-icon-s-opportunity',
                    link: '/boxs/software'
                },
                {
                    title: '电子保护膜系列',
                    desc: '硅胶保护膜,亚克力保护膜,抗静电保护膜',
                    icon: 'el-icon-s-cooperation',
                    link: '/boxs/integration'
                },
                {
                    title: '离型膜系列',
                    desc: 'PET透明离型膜,彩色离型膜,哑光离型膜。PE离型膜。PP离型膜,珠光离型膜',
                    icon: 'el-icon-s-management',
                    link: '/boxs/consulting'
                },
                {
                    title: '联系我们',
                    desc: '专业从喷绘写真材料制品的生产企业',
                    icon: 'el-icon-s-platform',
                    link: '/boxs/solutions'
                }
            ],
            newsTitle: '正在发生',
            moreNews: '探索更多',
            companyVideoTitle: '威海和祥泰数码科技有限公司',
            companyVideoDesc: '2017年，威海和祥泰数码科技有限公司经中华人民共和国商务部审批境外投资企业，同年5月7日在韩国成立了豪鸿株式会社公共海外仓。豪鸿株式会社地处韩国京畿道华城市，距离平泽港约30公里，距离仁川港约40公里，距离首尔机场50-60公里，交通便利。\n' +
                '\n',
            learnMore: '了解更多',
            joinUsTitle: '加入和祥泰',
            joinUsSub: '遇见新未来，发现新自己',
            joinUsDesc: '我们秉持能力导向、全面发展的人才理念，为有能力的员工提供广阔的发展舞台',
            joinUsButton: '加入我们',
            statisticsTitle: '企业成就',
            statisticsDesc: '和祥泰数码科技有限公司致力于成为行业领导者，以下是我们的一些成就数据'
        },
        footer: {
            about: {
                title: "关于和祥泰",
                companyIntro: "公司简介",
                history: "发展历程",
                team: "管理团队",
                organization: "组织架构",
                honors: "企业荣誉"
            },
            business: {
                title: "主营业务",
                overview: "业务概览",
                softwareDev: "软件开发",
                systemIntegration: "系统集成",
                techConsulting: "技术咨询",
                projects: "典型项目"
            },
            news: {
                title: "企业动态",
                newsInfo: "新闻资讯",
                mediaReports: "媒体报道",
                videoCenter: "视频中心",
                socialResponsibility: "社会责任"
            },
            recruit: {
                title: "人才招聘",
                positions: "招聘岗位",
                campus: "校园招聘",
                social: "社会招聘",
                intern: "实习生招聘"
            },
            contact: {
                title: "联系我们",
                address: "地址：威海崮山镇创新创业产业园内2号楼201室",
                phone: "联系电话：0631-5380169",
                fax: "传真：0631-5380166",
                emailName: '邮箱：18663127999',
                emailDomain: '163.com',
                wechat: "关注微信公众号"
            },
            company: {
                name: "和祥泰数码科技有限公司",
                slogan: "专业从喷绘写真材料制品的生产企业"
            },
            stock: {
                title: "证券信息",
                code: "股票代码",
                time: "截止时间"
            },
            copyright: {
                rights: "版权所有",
                icp: "ICP备",
                police: "公网安备"
            },
            nav: {
                privacy: "隐私政策",
                terms: "服务条款",
                sitemap: "网站地图",
                contact: "联系我们"
            }
        },
        about: {
            companyOverview: '公司概况',
            companyOverviewEn: 'Company profile',
            companyDesc: '公司地处风景秀美的海滨城市——山东省威海市。三面环海，海上交通十分便捷。公司距威海集装箱码头，仅需5分钟车程。公司占地200余亩。拥有一支多年从事喷绘写真材料制品生产经验的生产团队，以及管理团队。主要生产喷绘写真，RC感光膜，胶片光学膜，拥有一整套一流的生产设备和生产车间。公司致力于各种喷绘写真材料的生产与研发，始终秉承质量为企业第一生命线的理念，严格管理，竭诚为广大客户提供品质最优良的产品，产品畅销韩国，日本，美国，澳大利亚，新西兰，墨西哥，东南亚，欧洲等国家。',
            environmentTitle: '公司环境',
            environmentSubtitle: 'Company environment',
            companyIntroTitle: '公司介绍',
            companyIntroDesc: '了解和祥泰数码科技有限公司的企业文化和发展历程',
            videoNotSupported: '您的浏览器不支持视频播放',
            teamTitle: '分工公司团队',
            teamDesc: '和祥泰数码科技有限公司拥有一支充满激情和专业素养的精英团队'
        },
        historyPage: {
            header: '企业历史',
            sectionTitle: '我们的发展历程',
            sectionDesc: '从创立至今，我们不断创新发展，为客户提供更优质的服务和产品，见证了企业的成长与蜕变。',
            breadcrumb: {
                home: '首页',
                about: '关于我们',
                history: '企业历史'
            },
            timeline: {
                founded: {
                    title: '公司成立',
                    time: '2010年',
                    content: '公司在北京正式成立，初始团队由5名成员组成，专注于企业服务领域的软件开发'
                },
                productLaunch: {
                    title: '首款产品发布',
                    time: '2012年',
                    content: '成功研发并发布首款企业管理软件，获得市场良好反响'
                },
                seriesA: {
                    title: '首轮融资',
                    time: '2014年',
                    content: '完成A轮融资，金额1000万元，加速产品研发与市场推广'
                },
                expansion: {
                    title: '业务扩展',
                    time: '2016年',
                    content: '业务范围从软件开发扩展到企业云服务领域，同年在上海、深圳设立分公司'
                },
                global: {
                    title: '国际化发展',
                    time: '2018年',
                    content: '产品开始进入国际市场，在新加坡设立亚太区总部'
                },
                leading: {
                    title: '行业领先',
                    time: '2020年',
                    content: '公司成为行业领先企业，服务客户超过5000家，员工规模达到300人'
                },
                digital: {
                    title: '数字化转型',
                    time: '2022年',
                    content: '推出全新的数字化转型解决方案，助力企业实现智能化升级'
                },
                future: {
                    title: '展望未来',
                    time: '现在',
                    content: '持续创新，致力于成为全球领先的企业服务提供商'
                }
            },
            stats: {
                clients: '服务企业',
                awards: '行业奖项',
                branches: '全球分支',
                patents: '专利技术'
            },
            galleryTitle: '发展历程图片',
            galleryCaptions: {
                0: '公司成立初期',
                1: '公司成立初期',
                2: '公司成立初期',
                3: '公司成立初期',
                4: '公司成立初期',
                5: '产品发布会'
            }
        },
        teamPage: {
            title: '团队介绍',
            breadcrumb: {
                home: '首页',
                about: '关于我们',
                team: '团队介绍'
            },
            sectionTitle: '我们的管理团队',
            sectionDesc: '我们的团队由行业资深专家组成，拥有丰富的经验和创新精神，致力于为客户提供最优质的产品和服务。',
            loading: '加载团队成员数据中...',
            noData: '暂无团队成员信息',
            departmentTitle: '我们的专业团队',
            departmentDesc: '各个部门由优秀人才组成，协同工作，为企业发展提供强大支持。',
            teamCount: '团队人数',
            projectCount: '完成项目',
            coreMembers: '核心成员',
            cultureTitle: '企业文化与价值观',
            joinUsTitle: '加入我们的团队',
            joinUsDesc: '我们始终寻找优秀的人才加入团队，共同创造美好未来。',
            joinUsButton: '查看职位',
            departments: {
                research: {
                    name: '研发部',
                    desc: '负责产品研发和技术创新，致力于打造高质量的产品和服务。'
                },
                marketing: {
                    name: '市场部',
                    desc: '负责市场推广和品牌建设，制定有效的营销策略，提升品牌影响力。'
                },
                product: {
                    name: '产品部',
                    desc: '专注于产品设计和用户体验优化，深入了解用户需求，打造卓越产品。'
                }
            },
            values: {
                innovation: '创新',
                innovationDesc: '不断探索新技术、新方法，推动行业发展。',
                excellence: '卓越',
                excellenceDesc: '追求卓越品质，精益求精，为客户创造最大价值。',
                collaboration: '协作',
                collaborationDesc: '团队协作，共同成长，实现集体智慧的最大化。',
                integrity: '诚信',
                integrityDesc: '诚实守信，言行一致，赢得客户和合作伙伴信任。'
            }
        },
        organizationPage: {
            title: '组织架构',
            breadcrumb: {
                home: '首页',
                about: '关于我们',
                organization: '组织架构'
            },
            sectionTitle: '企业组织架构',
            sectionDesc: '我们拥有完善的组织管理体系，确保企业高效运转，为客户提供最优质的服务和产品。',
            loading: '加载组织架构数据中...',
            noData: '暂无组织架构数据',
            departmentMembersTitle: '部门成员',
            departmentResponsibilitiesTitle: '部门职责说明',
            departments: {
                presidentOffice: '总裁办公室',
                management: '管理层',
                technology: '技术部门',
                marketing: '市场部门',
                finance: '财务部门',
                hr: '人力资源部',
                legal: '法务部门'
            },
            responsibilities: {
                presidentOffice: [
                    '负责公司战略规划、业务协调、资源分配、决策执行等工作，是公司的核心管理机构。',
                    '制定和实施公司发展战略',
                    '协调各部门工作，提高运营效率',
                    '负责企业文化建设和企业形象维护',
                    '监督和评估公司业务执行情况'
                ],
                management: [
                    '公司核心决策层，负责公司整体战略方向和重大决策的制定与执行。',
                    '制定公司发展战略和年度目标',
                    '监督公司整体运营状况',
                    '审批重大决策和投资计划',
                    '统筹协调各部门工作'
                ],
                technology: [
                    '负责产品技术研发、架构设计、技术创新等工作，是企业核心竞争力的重要组成部分。',
                    '技术架构设计与实现',
                    '产品开发与维护',
                    '技术创新和研究',
                    '技术文档编写与管理',
                    '技术支持和问题解决'
                ],
                marketing: [
                    '负责市场调研、品牌推广、销售策略、客户开发等工作，拓展企业市场份额。',
                    '市场调研与分析',
                    '品牌建设与推广',
                    '销售策略制定与执行',
                    '客户开发与维护',
                    '营销活动策划与实施'
                ],
                finance: [
                    '负责公司财务管理、资金调配、预算编制、成本控制等工作，确保企业财务健康运行。',
                    '负责企业会计核算和财务管理',
                    '编制和执行企业预算',
                    '进行成本分析和控制',
                    '管理企业投资和融资活动',
                    '税务筹划和管理'
                ],
                hr: [
                    '负责人才招聘、培训发展、绩效管理、薪酬福利等工作，为企业发展提供人才保障。',
                    '招聘和配置人才资源',
                    '员工培训和职业发展规划',
                    '绩效评估和激励机制建设',
                    '薪酬福利管理',
                    '企业文化建设与员工关系管理'
                ],
                legal: [
                    '负责企业法律事务、合同管理、知识产权保护等工作，降低企业法律风险。',
                    '企业法律事务处理',
                    '合同审核与管理',
                    '知识产权保护',
                    '法律风险防范',
                    '法律咨询与支持'
                ]
            }
        },
        common: {
            home: '首页'
        },
        boxsPage: {
            title: '业务领域',
            subtitle: '和祥泰数码科技有限公司专业解决方案',
            banner: {
                title: '专业解决方案，助力企业发展',
                desc: '和祥泰数码科技有限公司为您提供全方位的技术服务与解决方案'
            },
            searchPlaceholder: '搜索业务领域关键词',
            searchResultsTitle: '搜索结果',
            noRelatedBusiness: '暂无相关业务',
            viewDetails: '查看详情',
            latestRelease: '最新发布',
            featuredSection: {
                title: '热门业务',
                desc: '我们的核心业务领域'
            },
            categoriesSection: {
                title: '业务分类',
                desc: '根据您的需求选择合适的解决方案'
            },
            categoryTabs: {
                '1': '电子胶带系列',
                '2': '电子保护膜系列',
                '3': '离型膜系列',
            },
            otherBusiness: '其他业务'
        },
        servicesPage: {
            common: {
                home: '首页'
            },
            boxsPage: {
                title: '业务领域'
            },
            title: '技术服务',
            subtitle: '和祥泰数码科技有限公司专业技术支持',
            ourServices: '我们的服务',
            description: '全方位的技术服务，满足您的各种需求',
            alertTitle: '该页面正在建设中，敬请期待',
            alertDescription: '我们正在整理技术服务内容，即将为您呈现'
        },
        projectsPage: {
            commonHome: '首页',
            title: '典型项目',
            subtitle: '和祥泰数码科技有限公司成功案例展示',
            classicCasesTitle: '经典项目案例',
            classicCasesDesc: '我们为不同行业客户提供了专业的解决方案',
            alertTitle: '该页面正在建设中，敬请期待',
            alertDescription: '我们正在整理企业优秀项目案例，即将为您呈现',
            boxsPageTitle: '业务领域'
        },
        recruitPage: {
            common: {
                cancel: "取消",
                submit: "提交",
                submitSuccess: "申请提交成功，我们会尽快与您联系",
                submitFail: "提交失败，请稍后重试",
                fetchFail: "获取数据失败，请稍后再试",
                nameLengthLimit: "姓名长度应在2到20个字符之间",
                invalidPhone: "请输入正确的手机号码",
                invalidEmail: "请输入正确的邮箱格式",
                invalidFileType: "只能上传PDF或Word格式的简历",
                fileTooLarge: "文件大小不能超过5MB",
                exceedFileLimit: "最多只能上传1个文件",
                unknown: "未知类型",
                noRequirement: "暂无详细职位要求"
            },
            title: "加入我们",
            subtitle: "与和祥泰数码科技有限公司一起创造未来",
            breadcrumbHome: "首页",
            breadcrumbCurrent: "人才招聘",

            culture: {
                alt: "公司文化",
                title: "公司文化",
                description: "在和祥泰数码科技有限公司，我们坚信人才是公司最宝贵的财富...",
                values: [
                    {icon: "el-icon-star-on", title: "创新", text: "拥抱变化，勇于创新，推动科技进步"},
                    {icon: "el-icon-s-cooperation", title: "协作", text: "团队合作，共同成长，实现共赢"},
                    {icon: "el-icon-s-flag", title: "卓越", text: "追求卓越，精益求精，超越自我"},
                    {icon: "el-icon-s-claim", title: "诚信", text: "诚实守信，言行一致，负责任"}
                ]
            },

            category: {
                title: "职位类别",
                description: "探索适合您的职业发展道路"
            },

            job: {
                loading: "加载职位数据中...",
                empty: "暂无相关职位信息",
                header: "我们寻找优秀人才，共同打造行业领先的产品",
                requirements: "任职要求",
                salary: "薪资范围",
                apply: "立即申请"
            },

            benefits: {
                title: "加入我们的理由",
                description: "我们提供具有竞争力的薪酬和完善的福利体系",
                items: [
                    {icon: "el-icon-medal", title: "具竞争力薪酬", text: "提供行业内具有竞争力的薪资水平和绩效奖金"},
                    {icon: "el-icon-first-aid-kit", title: "五险一金", text: "为员工提供完善的社会保险和住房公积金"},
                    {icon: "el-icon-sunrise", title: "带薪年假", text: "享受额外带薪年假和弹性工作时间"},
                    {icon: "el-icon-reading", title: "培训发展", text: "提供专业技能培训和职业发展规划"},
                    {icon: "el-icon-dessert", title: "团队活动", text: "定期组织团建活动和公司旅行"},
                    {icon: "el-icon-trophy", title: "晋升机会", text: "透明的晋升机制和广阔的职业发展空间"}
                ]
            },

            process: {
                title: "申请流程",
                description: "了解我们的招聘流程，做好充分准备",
                steps: [
                    {title: "简历投递", text: "通过官网或招聘平台投递您的简历"},
                    {title: "简历筛选", text: "HR团队初步筛选符合要求的简历"},
                    {title: "技术面试", text: "与技术团队进行专业能力面试"},
                    {title: "综合面试", text: "与部门负责人进行深入交流"},
                    {title: "offer发放", text: "发放录用通知，确认入职事宜"}
                ]
            },

            contact: {
                title: "联系我们",
                description: "如有任何招聘相关问题，请随时与我们联系",
                email: "招聘邮箱：18663127999@163.com",
                emailName: '招聘邮箱：',
                emailDomain: '18663127999',
                phone: '招聘热线：0631-5380169'
            },

            dialog: {
                title: "职位申请",
                form: {
                    name: "姓名",
                    phone: "电话",
                    email: "邮箱",
                    resume: "简历",
                    namePlaceholder: "请输入您的姓名",
                    phonePlaceholder: "请输入您的联系电话",
                    emailPlaceholder: "请输入您的邮箱地址",
                    chooseFile: "选择简历文件",
                    tip: "请上传PDF或Word格式的简历，文件大小不超过5MB"
                }
            }
        },
        contactPage: {
            navbar: {
                home: '首页',
                contact: '联系我们'
            },
            header: {
                title: '联系我们',
                subtitle: '随时与我们取得联系，我们期待您的反馈'
            },
            banner: {
                title: '让沟通更简单',
                desc: '无论您有任何问题、建议或合作意向，我们都随时准备倾听'
            },
            contactInfo: {
                title: '联系方式',
                addressTitle: '公司地址',
                address: '威海崮山镇创新创业产业园内2号楼201室',
                phoneTitle: '联系电话',
                faxTitle: '传真',
                emailTitle: '电子邮箱'
            },
            social: {
                title: '关注我们'
            },
            photos: {
                title: '公司环境',
                alt: '公司环境'
            },
            form: {
                title: '在线留言',
                desc: '如果您有任何问题或建议，请填写以下表单，我们会尽快回复您'
            },
            faq: {
                title: '常见问题',
                desc: '以下是客户常见的一些问题，希望能够帮助到您',
                q1: '如何联系你们的客服团队？',
                a1: '您可以通过以上提供的电话、邮箱与我们联系，也可以通过在线留言表单提交您的问题，我们的客服团队会在24小时内回复您。',
                q2: '你们提供上门服务吗？',
                a2: '是的，对于企业客户，我们提供上门技术支持和咨询服务，具体可与我们的客户经理联系安排。',
                q3: '如何申请产品演示？',
                a3: '您可以通过在线留言表单申请产品演示，或直接致电我们的销售部门。我们会安排专业的产品经理为您提供详细的产品演示。',
                q4: '你们的售后服务政策是什么？',
                a4: '我们为所有产品提供至少1年的免费技术支持和维护服务，部分产品可延长至3年。同时，我们提供7×24小时的紧急技术支持服务。'
            }
        },
        newsPage: {
            header: '企业动态',
            subtitle: '了解和祥泰数码科技有限公司的最新资讯和行业动态',
            breadcrumb: {
                home: '首页',
                news: '企业动态'
            },
            allCategories: '全部分类',
            categories: {
                company: '公司新闻',
                industry: '行业动态',
                tech: '技术洞察'
            },
            uncategorized: '未分类',
            fallbackMessage: '服务器暂时不可用，显示备用数据',
            fallbackMessageAlt: '无法连接到服务器，显示备用数据',
            noNews: '暂无相关新闻',
            fallback: {
                news1: {
                    title: '和祥泰数码科技有限公司成功完成B轮融资，估值达10亿元',
                    content: '...'
                },
                news2: {
                    title: '2023数字化转型高峰论坛圆满举行，和祥泰公司分享实践',
                    content: '...'
                }
            }
        },
        boxDetailPage: {
            header: "业务领域",
            subtitle: "和祥泰数码科技有限公司专业解决方案",
            breadcrumb: {
                home: "首页",
                business: "业务领域"
            },
            current: "业务详情",
            share: "分享至:",
            related: "相关业务",
            contact: {
                title: "联系我们",
                phone: "电话",
                email: "邮箱",
                address: "地址",
                btn: "立即咨询"
            }
        }

    },

    en: {
        contact: {
            title: 'Contact Us',
            description: 'If you have any questions or needs, please contact us through the form below. We will reply as soon as possible.',
            nameLabel: 'Your Name',
            namePlaceholder: 'Please enter your name',
            emailLabel: 'Your Email',
            emailPlaceholder: 'Please enter your email',
            phoneLabel: 'Your Phone',
            phonePlaceholder: 'Please enter your phone number',
            subjectLabel: 'Subject',
            subjectPlaceholder: 'Please select a subject',
            subjectOptions: {
                product: 'Product Inquiry',
                techSupport: 'Technical Support',
                cooperation: 'Cooperation',
                complaint: 'Complaint & Suggestion',
                other: 'Other'
            },
            messageLabel: 'Your Message',
            messagePlaceholder: 'Please describe your needs or questions in detail. We will reply as soon as possible.',
            submitButton: 'Submit Message',
            dialogConfirm: 'Confirm'
        },
        validation: {
            nameRequired: 'Please enter your name',
            nameLength: 'Name length should be between 2 and 20 characters',
            emailRequired: 'Please enter your email',
            emailInvalid: 'Please enter a valid email address',
            phoneRequired: 'Please enter your phone number',
            phoneInvalid: 'Please enter a valid phone number',
            subjectRequired: 'Please select a subject',
            messageRequired: 'Please enter your message',
            messageLength: 'Message length should be between 10 and 500 characters'
        },
        dialog: {
            successTitle: 'Submission Successful',
            successMessage: 'Thank you for your message. We will contact you shortly!',
            failTitle: 'Submission Failed',
            failMessage: 'Sorry, submission failed. Please try again later or contact us directly.'
        },
        navbar: {
            companyName: 'Xianghetai Digital Technology Co., Ltd.',
            home: 'Home',
            about: 'About Us',
            aboutCompany: 'Company Profile',
            aboutHistory: 'History',
            aboutTeam: 'Management Team',
            aboutOrg: 'Organization',
            news: 'News',
            newsInfo: 'News Info',
            boxs: 'Business',
            boxsOverview: 'Overview',
            boxsServices: 'Services',
            boxsProjects: 'Projects',
            recruits: 'Careers',
            touch: 'Contact',
            login: 'Admin',
            searchPlaceholder: 'Search',
            language: 'Language',
            languageNames: {
                zh: '中文',
                en: 'English',
                ja: '日本語',
                ko: '한국어',
            }
        },
        home: {
            slides: [
                {
                    title: 'Improve Life Quality for Everyone',
                    subtitle: 'Explore New Value',
                    button: 'Learn More',
                    buttonLink: '/about',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: 'Empowering Enterprises with Innovation',
                    subtitle: 'Tech-Driven Growth',
                    button: 'Our Services',
                    buttonLink: '/boxs',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: 'Build a Better Tomorrow Together',
                    subtitle: 'Sustainable Digital Future',
                    button: 'Join Us',
                    buttonLink: '/recruits',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                }
            ],
            statistics: {
                clientCount: "Clients",
                projectCount: "Projects",
                teamCount: "Team Members",
                satisfaction: "Customer Satisfaction"
            },
            business: [
                {
                    title: 'Electronic Tapes',
                    desc: 'Black and transparent single/double sided tapes',
                    icon: 'el-icon-s-opportunity',
                    link: '/boxs/software'
                },
                {
                    title: 'Protective Films',
                    desc: 'Silicone, acrylic, anti-static protective films',
                    icon: 'el-icon-s-cooperation',
                    link: '/boxs/integration'
                },
                {
                    title: 'Release Films',
                    desc: 'PET, PE, PP, matte, and pearl release films',
                    icon: 'el-icon-s-management',
                    link: '/boxs/consulting'
                },
                {
                    title: 'Contact Us',
                    desc: 'Professional producer of printing materials',
                    icon: 'el-icon-s-platform',
                    link: '/boxs/solutions'
                }
            ],
            newsTitle: 'What’s Happening',
            moreNews: 'Explore More',
            companyVideoTitle: 'Xianghetai Digital Technology Co., Ltd.',
            companyVideoDesc: 'In 2017, Weihai Hexiangtai Digital Technology Co., Ltd. was approved by the Ministry of Commerce of the People\'s Republic of China as an overseas investment enterprise. On May 7 of the same year, it established Hao Hong Co., Ltd. Public Overseas Warehouse in South Korea. Hao Hong Co., Ltd. is located in Hwaseong-si, Gyeonggi-do, South Korea, about 30 kilometers from Pyeongtaek Port, 40 kilometers from Incheon Port, and 50–60 kilometers from Seoul Airport, with convenient transportation.',
            learnMore: 'Learn More',
            joinUsTitle: 'Join Xianghetai',
            joinUsSub: 'Meet New Future, Discover Yourself',
            joinUsDesc: 'We value capability and growth, providing a broad platform for talents',
            joinUsButton: 'Join Us',
            statisticsTitle: 'Our Achievements',
            statisticsDesc: 'Committed to leadership in the industry, here are some key stats'
        },
        footer: {
            about: {
                title: "About Hexiangtai",
                companyIntro: "Company Profile",
                history: "Development History",
                team: "Management Team",
                organization: "Organization Structure",
                honors: "Corporate Honors"
            },
            business: {
                title: "Main Business",
                overview: "Business Overview",
                softwareDev: "Software Development",
                systemIntegration: "System Integration",
                techConsulting: "Technical Consulting",
                projects: "Typical Projects"
            },
            news: {
                title: "Corporate News",
                newsInfo: "News Information",
                mediaReports: "Media Reports",
                videoCenter: "Video Center",
                socialResponsibility: "Social Responsibility"
            },
            recruit: {
                title: "Careers",
                positions: "Job Openings",
                campus: "Campus Recruitment",
                social: "Social Recruitment",
                intern: "Internship"
            },
            contact: {
                title: "Contact Us",
                address: "Address: Room 201, Building 2, Innovation and Entrepreneurship Industrial Park, Gushan Town, Weihai",
                phone: "Phone: 0631-5380169",
                fax: "Fax: 0631-5380166",
                email: "Email: 18663127999@163.com",
                wechat: "Follow our WeChat Official Account"
            },
            company: {
                name: "Hexiangtai Digital Technology Co., Ltd.",
                slogan: "Professional Manufacturer of Spray Painting and Photo Materials"
            },
            stock: {
                title: "Stock Information",
                code: "Stock Code",
                time: "As of"
            },
            copyright: {
                rights: "All rights reserved",
                icp: "ICP No.",
                police: "Public Security No."
            },
            nav: {
                privacy: "Privacy Policy",
                terms: "Terms of Service",
                sitemap: "Site Map",
                contact: "Contact Us"
            }
        },
        about: {
            companyOverview: 'Company Overview',
            companyOverviewEn: 'Company profile',
            companyDesc: 'The company is located in the beautiful coastal city of Weihai, Shandong Province, surrounded by sea on three sides, with very convenient sea transportation. It is only a 5-minute drive from Weihai Container Terminal and covers more than 200 acres. We have a professional production and management team with years of experience in producing photo printing materials, RC photosensitive films, and optical films. With advanced production equipment and workshops, we are committed to R&D and quality as the lifeline of our company. Our products are popular in South Korea, Japan, the United States, Australia, New Zealand, Mexico, Southeast Asia, and Europe.',
            environmentTitle: 'Company Environment',
            environmentSubtitle: 'Company environment',
            companyIntroTitle: 'Company Introduction',
            companyIntroDesc: 'Learn about the corporate culture and development of Hexiangtai Digital Technology Co., Ltd.',
            videoNotSupported: 'Your browser does not support video playback.',
            teamTitle: 'Core Team',
            teamDesc: 'Hexiangtai Digital Technology Co., Ltd. has a passionate and professional elite team.'
        },
        breadcrumb: {
            home: "ホーム",
            about: "私たちについて",
        },
        historyPage: {
            header: 'Company History',
            sectionTitle: 'Our Development Journey',
            sectionDesc: 'Since our founding, we have continuously innovated and grown, providing better services and products to our clients, witnessing the company’s evolution and transformation.',
            breadcrumb: {
                home: 'Home',
                about: 'About Us',
                history: 'Company History'
            },
            timeline: {
                founded: {
                    title: 'Company Founded',
                    time: '2010',
                    content: 'The company was officially founded in Beijing with an initial team of five members, focusing on software development for enterprise services.'
                },
                productLaunch: {
                    title: 'First Product Launched',
                    time: '2012',
                    content: 'Successfully developed and launched the first enterprise management software, receiving positive market feedback.'
                },
                seriesA: {
                    title: 'Series A Funding',
                    time: '2014',
                    content: 'Completed Series A funding of 10 million CNY to accelerate product R&D and market expansion.'
                },
                expansion: {
                    title: 'Business Expansion',
                    time: '2016',
                    content: 'Expanded from software development to cloud services for enterprises, and established branches in Shanghai and Shenzhen.'
                },
                global: {
                    title: 'Global Expansion',
                    time: '2018',
                    content: 'Entered international markets and set up the Asia-Pacific headquarters in Singapore.'
                },
                leading: {
                    title: 'Industry Leader',
                    time: '2020',
                    content: 'Became a leading enterprise in the industry, serving over 5,000 clients with a team of 300 employees.'
                },
                digital: {
                    title: 'Digital Transformation',
                    time: '2022',
                    content: 'Launched a new digital transformation solution to help enterprises upgrade intelligently.'
                },
                future: {
                    title: 'Looking Ahead',
                    time: 'Present',
                    content: 'Continuing to innovate and striving to become a global leader in enterprise services.'
                }
            },
            stats: {
                clients: 'Clients Served',
                awards: 'Industry Awards',
                branches: 'Global Branches',
                patents: 'Patented Technologies'
            },
            galleryTitle: 'Development Gallery',
            galleryCaptions: {
                0: 'Early Days of the Company',
                1: 'Early Days of the Company',
                2: 'Early Days of the Company',
                3: 'Early Days of the Company',
                4: 'Early Days of the Company',
                5: 'Product Launch Event'
            }
        },
        teamPage: {
            title: 'Our Team',
            breadcrumb: {
                home: 'Home',
                about: 'About Us',
                team: 'Our Team'
            },
            sectionTitle: 'Our Management Team',
            sectionDesc:
                'Our team is composed of industry experts with extensive experience and innovation, committed to providing the best products and services.',
            loading: 'Loading team member data...',
            noData: 'No team member information available',
            departmentTitle: 'Our Professional Teams',
            departmentDesc: 'Each department is made up of talented individuals working together to support business development.',
            teamCount: 'Team Members',
            projectCount: 'Projects Completed',
            coreMembers: 'Core Members',
            cultureTitle: 'Corporate Culture & Values',
            joinUsTitle: 'Join Our Team',
            joinUsDesc:
                'We are always looking for great talent to join our team and build a better future together.',
            joinUsButton: 'View Jobs',
            departments: {
                research: {
                    name: 'Research & Development',
                    desc: 'Responsible for product development and technology innovation, committed to delivering high-quality products and services.'
                },
                marketing: {
                    name: 'Marketing',
                    desc: 'Responsible for marketing and brand building, developing effective marketing strategies to enhance brand influence.'
                },
                product: {
                    name: 'Product',
                    desc: 'Focuses on product design and user experience optimization, deeply understanding user needs to create excellent products.'
                }
            },
            values: {
                innovation: 'Innovation',
                innovationDesc: 'Exploring new technologies and methods to drive industry development.',
                excellence: 'Excellence',
                excellenceDesc: 'Pursuing high quality and creating maximum value for customers.',
                collaboration: 'Collaboration',
                collaborationDesc: 'Working together and growing as a team to maximize collective wisdom.',
                integrity: 'Integrity',
                integrityDesc: 'Honest and trustworthy, earning the trust of customers and partners.'
            }
        },
        organizationPage: {
            title: 'Organization',
            breadcrumb: {
                home: 'Home',
                about: 'About Us',
                organization: 'Organization'
            },
            sectionTitle: 'Corporate Organization',
            sectionDesc: 'We have a sound organizational management system to ensure efficient operation and provide the best products and services for our customers.',
            loading: 'Loading organization data...',
            noData: 'No organization data available',
            departmentMembersTitle: 'Department Members',
            departmentResponsibilitiesTitle: 'Department Responsibilities',
            departments: {
                presidentOffice: 'President Office',
                management: 'Management',
                technology: 'Technology Department',
                marketing: 'Marketing Department',
                finance: 'Finance Department',
                hr: 'Human Resources Department',
                legal: 'Legal Department'
            },
            responsibilities: {
                presidentOffice: [
                    'Responsible for company strategy planning, business coordination, resource allocation, and decision implementation, serving as the core management body.',
                    'Formulate and implement company development strategies',
                    'Coordinate work among departments to improve operational efficiency',
                    'Responsible for corporate culture construction and corporate image maintenance',
                    'Supervise and evaluate business execution'
                ],
                management: [
                    'Core decision-making level, responsible for overall strategic direction and major decisions.',
                    'Formulate development strategy and annual goals',
                    'Supervise overall operation status',
                    'Approve major decisions and investment plans',
                    'Coordinate departmental work'
                ],
                technology: [
                    'Responsible for product technical research and development, architecture design, and technical innovation, a key component of the company\'s core competitiveness.',
                    'Technical architecture design and implementation',
                    'Product development and maintenance',
                    'Technical innovation and research',
                    'Technical documentation writing and management',
                    'Technical support and problem solving'
                ],
                marketing: [
                    'Responsible for market research, brand promotion, sales strategy, and client development to expand market share.',
                    'Market research and analysis',
                    'Brand building and promotion',
                    'Sales strategy formulation and implementation',
                    'Client development and maintenance',
                    'Marketing event planning and execution'
                ],
                finance: [
                    'Responsible for financial management, fund allocation, budget preparation, and cost control to ensure financial health.',
                    'Accounting and financial management',
                    'Budget preparation and execution',
                    'Cost analysis and control',
                    'Investment and financing management',
                    'Tax planning and management'
                ],
                hr: [
                    'Responsible for recruitment, training and development, performance management, and compensation to ensure talent supply.',
                    'Recruitment and allocation of talent',
                    'Employee training and career planning',
                    'Performance evaluation and incentive mechanisms',
                    'Compensation and benefits management',
                    'Corporate culture and employee relations management'
                ],
                legal: [
                    'Responsible for legal affairs, contract management, intellectual property protection to reduce legal risks.',
                    'Handling legal affairs',
                    'Contract review and management',
                    'Intellectual property protection',
                    'Legal risk prevention',
                    'Legal consultation and support'
                ]
            }
        },
        common: {
            home: 'Home'
        },
        boxsPage: {
            title: 'Business Areas',
            subtitle: 'HeXiangTai Digital Technology Co., Ltd. Professional Solutions',
            banner: {
                title: 'Professional solutions to empower enterprise growth',
                desc: 'HeXiangTai Digital Technology provides you with comprehensive technical services and solutions'
            },
            searchPlaceholder: 'Search business area keywords',
            searchResultsTitle: 'Search Results',
            noRelatedBusiness: 'No related business found',
            viewDetails: 'View Details',
            latestRelease: 'Latest Releases',
            featuredSection: {
                title: 'Featured Services',
                desc: 'Our core business areas'
            },
            categoriesSection: {
                title: 'Business Categories',
                desc: 'Choose the right solution based on your needs'
            },
            categoryTabs: {
                '1': 'Enterprise Services',
                '2': 'Technology Innovation',
                '3': 'Digital Infrastructure',
            },
            otherBusiness: 'Other Business'
        },
        servicesPage: {
            common: {
                home: 'Home'
            },
            boxsPage: {
                title: 'Business Areas'
            },
            title: 'Technical Services',
            subtitle: 'HeXiangTai Digital Technology Co., Ltd. Professional Technical Support',
            ourServices: 'Our Services',
            description: 'Comprehensive technical services to meet your various needs',
            alertTitle: 'This page is under construction, please stay tuned',
            alertDescription: 'We are organizing technical service content and will present it soon'
        },
        projectsPage: {
            commonHome: 'Home',
            title: 'Typical Projects',
            subtitle: 'Success Cases of Hexiangtai Digital Technology Co., Ltd.',
            classicCasesTitle: 'Classic Project Cases',
            classicCasesDesc: 'We provide professional solutions for customers from different industries.',
            alertTitle: 'This page is under construction, please stay tuned',
            alertDescription: 'We are organizing excellent project cases and will present them to you soon.',
            boxsPageTitle: 'Business Areas'
        },
        recruitPage: {
            common: {
                cancel: "Cancel",
                submit: "Submit",
                submitSuccess: "Application submitted successfully. We will contact you as soon as possible.",
                submitFail: "Submission failed, please try again later.",
                fetchFail: "Failed to fetch data, please try again later.",
                nameLengthLimit: "Name length should be between 2 and 20 characters.",
                invalidPhone: "Please enter a valid phone number.",
                invalidEmail: "Please enter a valid email address.",
                invalidFileType: "Only PDF or Word resumes are allowed.",
                fileTooLarge: "File size cannot exceed 5MB.",
                exceedFileLimit: "You can only upload 1 file at most.",
                unknown: "Unknown type",
                noRequirement: "No detailed job requirements available."
            },
            title: "Join Us",
            subtitle: "Create the future together with Yifantech Digital Technology Co., Ltd.",
            breadcrumbHome: "Home",
            breadcrumbCurrent: "Careers",

            culture: {
                alt: "Company Culture",
                title: "Company Culture",
                description: "At Yifantech Digital Technology Co., Ltd., we firmly believe that talent is the company's most valuable asset...",
                values: [
                    {
                        icon: "el-icon-star-on",
                        title: "Innovation",
                        text: "Embrace change, dare to innovate, and drive technological progress"
                    },
                    {
                        icon: "el-icon-s-cooperation",
                        title: "Collaboration",
                        text: "Work as a team, grow together, and achieve win-win results"
                    },
                    {
                        icon: "el-icon-s-flag",
                        title: "Excellence",
                        text: "Pursue excellence, strive for perfection, and surpass yourself"
                    },
                    {
                        icon: "el-icon-s-claim",
                        title: "Integrity",
                        text: "Be honest and trustworthy, consistent in words and actions, responsible"
                    }
                ]
            },

            category: {
                title: "Job Categories",
                description: "Explore career paths suitable for you"
            },

            job: {
                loading: "Loading job data...",
                empty: "No relevant job information available",
                header: "We are looking for outstanding talents to create industry-leading products together",
                requirements: "Job Requirements",
                salary: "Salary Range",
                apply: "Apply Now"
            },

            benefits: {
                title: "Reasons to Join Us",
                description: "We offer competitive salaries and comprehensive benefits",
                items: [
                    {
                        icon: "el-icon-medal",
                        title: "Competitive Salary",
                        text: "Provide industry-competitive salary levels and performance bonuses"
                    },
                    {
                        icon: "el-icon-first-aid-kit",
                        title: "Social Insurance & Housing Fund",
                        text: "Offer comprehensive social insurance and housing provident fund"
                    },
                    {
                        icon: "el-icon-sunrise",
                        title: "Paid Annual Leave",
                        text: "Enjoy extra paid annual leave and flexible working hours"
                    },
                    {
                        icon: "el-icon-reading",
                        title: "Training & Development",
                        text: "Provide professional skill training and career development plans"
                    },
                    {
                        icon: "el-icon-dessert",
                        title: "Team Activities",
                        text: "Regularly organize team-building activities and company trips"
                    },
                    {
                        icon: "el-icon-trophy",
                        title: "Promotion Opportunities",
                        text: "Transparent promotion mechanism and broad career development space"
                    }
                ]
            },

            process: {
                title: "Application Process",
                description: "Understand our recruitment process and prepare adequately",
                steps: [
                    {
                        title: "Resume Submission",
                        text: "Submit your resume through the official website or recruitment platforms"
                    },
                    {title: "Resume Screening", text: "HR team preliminarily screens resumes that meet requirements"},
                    {
                        title: "Technical Interview",
                        text: "Conduct a professional ability interview with the technical team"
                    },
                    {title: "Comprehensive Interview", text: "Have an in-depth conversation with the department head"},
                    {title: "Offer Issuance", text: "Issue employment offer and confirm onboarding details"}
                ]
            },

            contact: {
                title: "Contact Us",
                description: "If you have any questions related to recruitment, please feel free to contact us",
                email: "Recruitment Email: 18663127999@163.com",
                emailName: 'Recruitment Email:',
                emailDomain: '18663127999',
                phone: "Recruitment Hotline: 0631-5380166"
            },

            dialog: {
                title: "Job Application",
                form: {
                    name: "Name",
                    phone: "Phone",
                    email: "Email",
                    resume: "Resume",
                    namePlaceholder: "Please enter your name",
                    phonePlaceholder: "Please enter your phone number",
                    emailPlaceholder: "Please enter your email address",
                    chooseFile: "Choose resume file",
                    tip: "Please upload a PDF or Word format resume, file size no more than 5MB"
                }
            }
        },
        contactPage: {
            navbar: {
                home: 'Home',
                contact: 'Contact Us'
            },
            header: {
                title: 'Contact Us',
                subtitle: 'Reach out to us anytime — we look forward to your feedback'
            },
            banner: {
                title: 'Make Communication Easier',
                desc: 'Whether you have questions, suggestions, or partnership ideas, we are always ready to listen'
            },
            contactInfo: {
                title: 'Contact Information',
                addressTitle: 'Company Address',
                address: 'Room 201, Building 2, Innovation Park, Gushan Town, Weihai',
                phoneTitle: 'Phone Number',
                faxTitle: 'Fax',
                emailTitle: 'Email'
            },
            social: {
                title: 'Follow Us'
            },
            photos: {
                title: 'Office Environment',
                alt: 'Company Environment'
            },
            form: {
                title: 'Online Message',
                desc: 'If you have any questions or suggestions, please fill out the form below and we will get back to you as soon as possible'
            },
            faq: {
                title: 'FAQs',
                desc: 'Here are some common questions from our clients. Hope they help you.',
                q1: 'How can I contact your customer service team?',
                a1: 'You can contact us by phone or email listed above, or submit your inquiry through the online form. Our team will respond within 24 hours.',
                q2: 'Do you provide on-site services?',
                a2: 'Yes, we offer on-site technical support and consulting for business clients. Please contact our manager to arrange.',
                q3: 'How to request a product demo?',
                a3: 'You can submit a demo request via the online form or call our sales team. We will arrange a professional manager to provide a detailed demonstration.',
                q4: 'What is your after-sales service policy?',
                a4: 'We provide at least 1 year of free tech support and maintenance. Some products are eligible for up to 3 years. We also offer 24/7 emergency support.'
            }
        },
        newsPage: {
            header: 'Company News',
            subtitle: 'Stay updated with the latest from Hexiangtai Digital Technology Co., Ltd.',
            breadcrumb: {
                home: 'Home',
                news: 'News'
            },
            allCategories: 'All Categories',
            categories: {
                company: 'Company News',
                industry: 'Industry Trends',
                tech: 'Tech Insights'
            },
            uncategorized: 'Uncategorized',
            fallbackMessage: 'Server temporarily unavailable, showing fallback data',
            fallbackMessageAlt: 'Unable to connect to server, showing fallback data',
            noNews: 'No related news found',
            fallback: {
                news1: {
                    title: 'Hexiangtai Digital Technology Co., Ltd. Completes Series B Funding at 1 Billion Valuation',
                    content: '...'
                },
                news2: {
                    title: '2023 Digital Transformation Summit Held Successfully, Hexiangtai Shares Insights',
                    content: '...'
                }
            }
        },
        boxDetailPage: {
            header: "Business Domain",
            subtitle: "Hexiangtai Digital Technology Co., Ltd. Professional Solutions",
            breadcrumb: {
                home: "Home",
                business: "Business Domain"
            },
            current: "Business Detail",
            share: "Share to:",
            related: "Related Business",
            contact: {
                title: "Contact Us",
                phone: "Phone",
                email: "Email",
                address: "Address",
                btn: "Consult Now"
            }
        }


    },

    ja: {
        contact: {
            title: 'お問い合わせ',
            description: 'ご質問やご要望がございましたら、以下のフォームからお問い合わせください。できるだけ早く返信いたします。',
            nameLabel: 'お名前',
            namePlaceholder: 'お名前を入力してください',
            emailLabel: 'メールアドレス',
            emailPlaceholder: 'メールアドレスを入力してください',
            phoneLabel: '電話番号',
            phonePlaceholder: '電話番号を入力してください',
            subjectLabel: '件名',
            subjectPlaceholder: 'お問い合わせの件名を選択してください',
            subjectOptions: {
                product: '製品に関するお問い合わせ',
                techSupport: '技術サポート',
                cooperation: '協力交渉',
                complaint: '苦情・提案',
                other: 'その他'
            },
            messageLabel: 'メッセージ',
            messagePlaceholder: 'ご要望や問題を詳しくご記入ください。できるだけ早く返信いたします。',
            submitButton: 'メッセージを送信',
            dialogConfirm: '確認'
        },
        validation: {
            nameRequired: 'お名前を入力してください',
            nameLength: 'お名前は2〜20文字の間で入力してください',
            emailRequired: 'メールアドレスを入力してください',
            emailInvalid: '正しいメールアドレスを入力してください',
            phoneRequired: '電話番号を入力してください',
            phoneInvalid: '正しい電話番号を入力してください',
            subjectRequired: 'お問い合わせの件名を選択してください',
            messageRequired: 'メッセージを入力してください',
            messageLength: 'メッセージは10〜500文字の間で入力してください'
        },
        dialog: {
            successTitle: '送信成功',
            successMessage: 'メッセージを受け取りました。できるだけ早くご連絡いたします。',
            failTitle: '送信失敗',
            failMessage: '申し訳ありません。送信に失敗しました。後でもう一度お試しいただくか、直接お問い合わせください。'
        },
        navbar: {
            companyName: '祥和泰デジタルテクノロジー株式会社',
            home: 'ホーム',
            about: '会社情報',
            aboutCompany: '会社概要',
            aboutHistory: '沿革',
            aboutTeam: '経営陣',
            aboutOrg: '組織図',
            news: 'ニュース',
            newsInfo: 'ニュース詳細',
            boxs: '事業分野',
            boxsOverview: '概要',
            boxsServices: 'サービス',
            boxsProjects: 'プロジェクト',
            recruits: '採用情報',
            touch: 'お問い合わせ',
            login: 'ログイン',
            searchPlaceholder: '検索',
            language: '言語',
            languageNames: {
                zh: '中文',
                en: 'English',
                ja: '日本語',
                ko: '한국어',
            }
        },
        home: {
            statistics: {
                clientCount: "顧客数",
                projectCount: "プロジェクト数",
                teamCount: "チーム人数",
                satisfaction: "顧客満足度"
            }
            ,
            slides: [
                {
                    title: 'より良い暮らしを実現',
                    subtitle: '新しい価値を創造',
                    button: 'もっと見る',
                    buttonLink: '/about',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: 'デジタル変革を推進',
                    subtitle: '技術で未来を創る',
                    button: '事業内容',
                    buttonLink: '/boxs',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: '持続可能な社会へ',
                    subtitle: '共に未来を創造',
                    button: '参加する',
                    buttonLink: '/recruits',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                }
            ],
            business: [
                {
                    title: '電子テープ',
                    desc: '黒・透明 単面/両面テープ',
                    icon: 'el-icon-s-opportunity',
                    link: '/boxs/software'
                },
                {
                    title: '保護フィルム',
                    desc: 'シリコン・アクリル・帯電防止フィルム',
                    icon: 'el-icon-s-cooperation',
                    link: '/boxs/integration'
                },
                {
                    title: '離型フィルム',
                    desc: 'PET・PE・PP・マット・パール離型フィルム',
                    icon: 'el-icon-s-management',
                    link: '/boxs/consulting'
                },
                {
                    title: 'お問い合わせ',
                    desc: '高品質な印刷材料の製造業者',
                    icon: 'el-icon-s-platform',
                    link: '/boxs/solutions'
                }
            ],
            newsTitle: '最新情報',
            moreNews: 'さらに見る',
            companyVideoTitle: '祥和泰デジタルテクノロジー株式会社',
            companyVideoDesc: '2017年、威海和祥泰デジタルテクノロジー有限公司は中華人民共和国商務部の承認を得て海外投資企業となり、同年5月7日に韓国にて豪鴻株式会社の公共海外倉庫を設立しました。豪鴻株式会社は韓国京畿道華城市に位置し、平沢港から約30km、仁川港から約40km、ソウル空港からは約50〜60kmの距離にあり、交通の便が良いです。',
            learnMore: 'もっと見る',
            joinUsTitle: 'チームに参加',
            joinUsSub: '新しい未来へ一歩を踏み出す',
            joinUsDesc: '実力を重視し、成長の機会を提供します。',
            joinUsButton: '参加する',
            statisticsTitle: '企業成果',
            statisticsDesc: '業界のリーダーを目指して、以下は当社の成果です。'
        },
        footer: {
            about: {
                title: "和祥泰について",
                companyIntro: "会社概要",
                history: "沿革",
                team: "経営チーム",
                organization: "組織構成",
                honors: "企業の栄誉"
            },
            business: {
                title: "主な事業",
                overview: "事業概要",
                softwareDev: "ソフトウェア開発",
                systemIntegration: "システム統合",
                techConsulting: "技術コンサルティング",
                projects: "代表的なプロジェクト"
            },
            news: {
                title: "企業ニュース",
                newsInfo: "ニュース情報",
                mediaReports: "メディア報道",
                videoCenter: "ビデオセンター",
                socialResponsibility: "社会的責任"
            },
            recruit: {
                title: "採用情報",
                positions: "募集職種",
                campus: "新卒採用",
                social: "中途採用",
                intern: "インターンシップ"
            },
            contact: {
                title: "お問い合わせ",
                address: "住所：威海崮山鎮イノベーション起業産業園2号館201室",
                phone: "電話番号：0631-5380169",
                fax: "FAX：0631-5380166",
                email: "メール：18663127999@163.com",
                wechat: "公式WeChatアカウントをフォロー"
            },
            company: {
                name: "和祥泰デジタルテクノロジー株式会社",
                slogan: "スプレーペイントおよび写真材料の専門製造会社"
            },
            stock: {
                title: "株式情報",
                code: "証券コード",
                time: "締切日時"
            },
            copyright: {
                rights: "著作権所有",
                icp: "ICP番号",
                police: "公安備案番号"
            },
            nav: {
                privacy: "プライバシーポリシー",
                terms: "利用規約",
                sitemap: "サイトマップ",
                contact: "お問い合わせ"
            }
        },
        about: {
            companyOverview: '会社概要',
            companyOverviewEn: 'Company profile',
            companyDesc: '当社は中国山東省威海市の美しい海辺の都市に位置しています。三方を海に囲まれ、海上交通が非常に便利です。威海コンテナターミナルまで車でわずか5分の距離にあり、敷地面積は200ムー以上です。長年にわたりインクジェットメディア製品の製造に従事してきた生産チームおよび管理チームを有し、RC感光フィルム、光学フィルムの生産において一流の設備と工場を備えています。常に「品質は企業の命綱」という理念を堅持し、厳格な管理を行い、お客様に最高品質の製品を提供しています。製品は韓国、日本、アメリカ、オーストラリア、ニュージーランド、メキシコ、東南アジア、ヨーロッパなどに輸出されています。',
            environmentTitle: '会社環境',
            environmentSubtitle: 'Company environment',
            companyIntroTitle: '会社紹介',
            companyIntroDesc: '和祥泰数码科技有限公司の企業文化と発展の歴史をご紹介します。',
            videoNotSupported: 'お使いのブラウザは動画再生に対応していません。',
            teamTitle: 'コアチーム',
            teamDesc: '和祥泰数码科技有限公司は、情熱と専門性を兼ね備えた精鋭チームを有しています。'
        },
        breadcrumb: {
            home: "Home",
            about: "About Us",
        },
        historyPage: {
            header: '企業の歴史',
            sectionTitle: '発展の歩み',
            sectionDesc: '創業以来、常に革新と成長を続け、より良いサービスと製品を提供し、企業の成長と変革を見届けてきました。',
            breadcrumb: {
                home: 'ホーム',
                about: '会社概要',
                history: '企業の歴史'
            },
            timeline: {
                founded: {
                    title: '会社設立',
                    time: '2010年',
                    content: '北京で正式に設立。初期メンバーは5名で、企業向けサービスのソフトウェア開発に注力。'
                },
                productLaunch: {
                    title: '初製品のリリース',
                    time: '2012年',
                    content: '最初の企業管理ソフトを開発・リリースし、市場から好評を得る。'
                },
                seriesA: {
                    title: 'シリーズA資金調達',
                    time: '2014年',
                    content: '1,000万元のシリーズA資金調達を完了し、製品開発と市場拡大を加速。'
                },
                expansion: {
                    title: '事業拡大',
                    time: '2016年',
                    content: 'ソフトウェア開発からクラウドサービスへ拡大し、上海と深センに支社を設立。'
                },
                global: {
                    title: '国際展開',
                    time: '2018年',
                    content: '国際市場に参入し、シンガポールにアジア太平洋本部を設立。'
                },
                leading: {
                    title: '業界のリーダーへ',
                    time: '2020年',
                    content: '業界をリードする企業となり、5,000社以上の顧客にサービスを提供。従業員数は300人に拡大。'
                },
                digital: {
                    title: 'デジタル変革',
                    time: '2022年',
                    content: '新しいデジタルトランスフォーメーションソリューションを発表し、企業のスマートアップグレードを支援。'
                },
                future: {
                    title: '未来への展望',
                    time: '現在',
                    content: '継続的な革新を目指し、世界的な企業サービス提供者を目指す。'
                }
            },
            stats: {
                clients: '取引企業',
                awards: '業界賞',
                branches: 'グローバル支社',
                patents: '特許技術'
            },
            galleryTitle: '成長の軌跡ギャラリー',
            galleryCaptions: {
                0: '創業初期の様子',
                1: '創業初期の様子',
                2: '創業初期の様子',
                3: '創業初期の様子',
                4: '創業初期の様子',
                5: '製品発表会'
            }
        },
        teamPage: {
            title: 'チーム紹介',
            breadcrumb: {
                home: 'ホーム',
                about: '会社概要',
                team: 'チーム紹介'
            },
            sectionTitle: '私たちの経営チーム',
            sectionDesc: '当社のチームは業界の専門家で構成され、豊富な経験と革新精神を持ち、最高の製品とサービスを提供します。',
            loading: 'チームメンバーのデータを読み込み中...',
            noData: 'チームメンバーの情報はありません',
            departmentTitle: '私たちの専門チーム',
            departmentDesc: '各部門は優秀な人材で構成され、企業の発展を強力に支援しています。',
            teamCount: 'チームメンバー数',
            projectCount: '完了したプロジェクト',
            coreMembers: '主要メンバー',
            cultureTitle: '企業文化と価値観',
            joinUsTitle: '私たちのチームに参加する',
            joinUsDesc: '私たちは常に優秀な人材を探しており、一緒により良い未来を創造しましょう。',
            joinUsButton: '募集職を見る',
            departments: {
                research: {
                    name: '研究開発部',
                    desc: '製品の研究開発と技術革新を担当し、高品質な製品とサービスの提供に努めています。'
                },
                marketing: {
                    name: 'マーケティング部',
                    desc: 'マーケティング促進とブランド構築を担当し、効果的なマーケティング戦略を策定してブランドの影響力を高めます。'
                },
                product: {
                    name: '製品部',
                    desc: '製品設計とユーザー体験の最適化に専念し、ユーザーのニーズを深く理解して卓越した製品を作り上げます。'
                }
            },
            values: {
                innovation: 'イノベーション',
                innovationDesc: '新技術や新手法を継続的に探求し、業界の発展を推進します。',
                excellence: '卓越性',
                excellenceDesc: '卓越した品質を追求し、絶えず改善し、お客様に最大の価値を提供します。',
                collaboration: '協力',
                collaborationDesc: 'チームワークと共に成長し、集団の知恵を最大化します。',
                integrity: '誠実さ',
                integrityDesc: '正直で信頼できる言動を守り、お客様やパートナーの信頼を得ています。'
            }
        },
        organizationPage: {
            title: '組織構造',
            breadcrumb: {
                home: 'ホーム',
                about: '会社概要',
                organization: '組織構造'
            },
            sectionTitle: '企業組織構造',
            sectionDesc: '効率的な運営を確保し、最高の製品とサービスを提供するために、健全な組織管理体制を持っています。',
            loading: '組織データを読み込み中...',
            noData: '組織データがありません',
            departmentMembersTitle: '部署メンバー',
            departmentResponsibilitiesTitle: '部署の役割説明',
            departments: {
                presidentOffice: '社長室',
                management: '経営陣',
                technology: '技術部門',
                marketing: 'マーケティング部門',
                finance: '財務部門',
                hr: '人事部',
                legal: '法務部'
            },
            responsibilities: {
                presidentOffice: [
                    '会社の戦略計画、業務調整、資源配分、意思決定の実行を担当し、会社の中核管理機関です。',
                    '会社の発展戦略の策定と実施',
                    '各部署の業務調整と運営効率の向上',
                    '企業文化の構築と企業イメージの維持',
                    '業務実行状況の監督と評価'
                ],
                management: [
                    '会社の中核意思決定層であり、全体の戦略方向と重要な決定を担当。',
                    '会社の発展戦略と年度目標の策定',
                    '会社全体の運営状況の監督',
                    '重要な決定と投資計画の承認',
                    '各部署の調整管理'
                ],
                technology: [
                    '製品の技術研究開発、アーキテクチャ設計、技術革新を担当し、企業の競争力の重要な部分です。',
                    '技術アーキテクチャの設計と実装',
                    '製品の開発と保守',
                    '技術革新と研究',
                    '技術文書の作成と管理',
                    '技術サポートと問題解決'
                ],
                marketing: [
                    '市場調査、ブランドプロモーション、販売戦略、顧客開発を担当し、市場シェアを拡大します。',
                    '市場調査と分析',
                    'ブランド構築とプロモーション',
                    '販売戦略の策定と実施',
                    '顧客開発と維持',
                    'マーケティングイベントの企画と実行'
                ],
                finance: [
                    '財務管理、資金配分、予算作成、コスト管理を担当し、企業の財務の健全性を確保します。',
                    '会計と財務管理',
                    '予算の作成と実行',
                    'コスト分析と管理',
                    '投資と資金調達の管理',
                    '税務計画と管理'
                ],
                hr: [
                    '人材採用、研修・育成、評価管理、給与福利厚生を担当し、企業の人材供給を支えます。',
                    '人材の採用と配置',
                    '従業員の研修とキャリアプランニング',
                    '評価とインセンティブの仕組み',
                    '給与と福利厚生の管理',
                    '企業文化と従業員関係の管理'
                ],
                legal: [
                    '法務、契約管理、知的財産保護を担当し、法的リスクを軽減します。',
                    '法務業務の処理',
                    '契約の審査と管理',
                    '知的財産の保護',
                    '法的リスクの予防',
                    '法的相談と支援'
                ]
            }
        },
        common: {
            home: 'ホーム'
        },
        boxsPage: {
            title: '事業分野',
            subtitle: '和祥泰デジタルテクノロジー株式会社の専門的なソリューション',
            banner: {
                title: '専門的なソリューションで企業の成長を支援',
                desc: '和祥泰デジタルテクノロジー株式会社は包括的な技術サービスとソリューションを提供します'
            },
            searchPlaceholder: '事業分野のキーワードを検索',
            searchResultsTitle: '検索結果',
            noRelatedBusiness: '関連する事業はありません',
            viewDetails: '詳細を見る',
            latestRelease: '最新のリリース',
            featuredSection: {
                title: '注目のサービス',
                desc: '私たちのコアビジネス分野'
            },
            categoriesSection: {
                title: '事業カテゴリ',
                desc: 'ニーズに応じた適切なソリューションを選択してください'
            },
            categoryTabs: {
                '1': '企業サービス',
                '2': '技術革新',
                '3': 'デジタルインフラ',
            },
            otherBusiness: 'その他の事業'
        },
        servicesPage: {
            common: {
                home: 'ホーム'
            },
            boxsPage: {
                title: '事業分野'
            },
            title: '技術サービス',
            subtitle: '和祥泰デジタルテクノロジー株式会社の専門技術サポート',
            ourServices: '私たちのサービス',
            description: 'あらゆるニーズに対応する包括的な技術サービス',
            alertTitle: 'このページは現在準備中です。ご期待ください',
            alertDescription: '技術サービスの内容を整理中で、まもなくご提供いたします'
        },
        projectsPage: {
            commonHome: 'ホーム',
            title: '代表的なプロジェクト',
            subtitle: '和祥泰デジタルテクノロジー株式会社の成功事例',
            classicCasesTitle: 'クラシックプロジェクト事例',
            classicCasesDesc: 'さまざまな業界のお客様に専門的なソリューションを提供しています。',
            alertTitle: '現在このページは工事中です。ご期待ください。',
            alertDescription: '優れたプロジェクト事例を整理中で、まもなく公開予定です。',
            boxsPageTitle: '事業分野'
        },
        recruitPage: {
            common: {
                cancel: "キャンセル",
                submit: "送信",
                submitSuccess: "応募が正常に送信されました。できるだけ早くご連絡いたします。",
                submitFail: "送信に失敗しました。後でもう一度お試しください。",
                fetchFail: "データの取得に失敗しました。後でもう一度お試しください。",
                nameLengthLimit: "名前の長さは2〜20文字である必要があります。",
                invalidPhone: "有効な電話番号を入力してください。",
                invalidEmail: "有効なメールアドレスを入力してください。",
                invalidFileType: "PDFまたはWord形式の履歴書のみアップロードできます。",
                fileTooLarge: "ファイルサイズは5MBを超えることはできません。",
                exceedFileLimit: "アップロードできるファイルは最大1つまでです。",
                unknown: "不明なタイプ",
                noRequirement: "詳細な職務要件はありません。"
            },
            title: "私たちと一緒に働きませんか",
            subtitle: "和祥泰デジタルテクノロジー株式会社と共に未来を創造しましょう",
            breadcrumbHome: "ホーム",
            breadcrumbCurrent: "採用情報",

            culture: {
                alt: "企業文化",
                title: "企業文化",
                description: "和祥泰デジタルテクノロジー株式会社では、人材は会社の最も貴重な資産であると確信しています...",
                values: [
                    {
                        icon: "el-icon-star-on",
                        title: "イノベーション",
                        text: "変化を受け入れ、革新を恐れず、技術の進歩を推進する"
                    },
                    {
                        icon: "el-icon-s-cooperation",
                        title: "協力",
                        text: "チームワークを重視し、共に成長し、ウィンウィンを実現する"
                    },
                    {icon: "el-icon-s-flag", title: "卓越", text: "卓越を追求し、完璧を目指し、自分を超える"},
                    {icon: "el-icon-s-claim", title: "誠実", text: "正直で信頼でき、言行一致し、責任感を持つ"}
                ]
            },

            category: {
                title: "職種カテゴリー",
                description: "あなたに合ったキャリアパスを探求しましょう"
            },

            job: {
                loading: "職務データを読み込み中...",
                empty: "関連する職務情報はありません",
                header: "優秀な人材を求め、業界をリードする製品を共に作り上げます",
                requirements: "応募条件",
                salary: "給与範囲",
                apply: "今すぐ応募"
            },

            benefits: {
                title: "私たちと働く理由",
                description: "競争力のある給与と充実した福利厚生を提供しています",
                items: [
                    {
                        icon: "el-icon-medal",
                        title: "競争力のある給与",
                        text: "業界内で競争力のある給与水準と業績ボーナスを提供"
                    },
                    {
                        icon: "el-icon-first-aid-kit",
                        title: "社会保険と住宅積立金",
                        text: "充実した社会保険と住宅積立金を提供"
                    },
                    {icon: "el-icon-sunrise", title: "有給休暇", text: "追加の有給休暇とフレックスタイム制を享受"},
                    {icon: "el-icon-reading", title: "研修と成長", text: "専門的なスキル研修とキャリア開発計画を提供"},
                    {
                        icon: "el-icon-dessert",
                        title: "チーム活動",
                        text: "定期的にチームビルディング活動や社員旅行を開催"
                    },
                    {icon: "el-icon-trophy", title: "昇進の機会", text: "透明な昇進制度と広いキャリア開発の機会"}
                ]
            },

            process: {
                title: "応募プロセス",
                description: "採用プロセスを理解し、十分に準備しましょう",
                steps: [
                    {title: "履歴書提出", text: "公式サイトまたは採用プラットフォームを通じて履歴書を提出"},
                    {title: "履歴書選考", text: "HRチームが条件に合う履歴書を初期選考"},
                    {title: "技術面接", text: "技術チームと専門能力面接を実施"},
                    {title: "総合面接", text: "部門責任者と深い対話"},
                    {title: "内定通知", text: "採用通知を発行し、入社詳細を確認"}
                ]
            },

            contact: {
                title: "お問い合わせ",
                description: "採用に関する質問があれば、お気軽にご連絡ください",
                email: "採用メール：hr@yifantech.com",
                phone: "採用ホットライン：0631-5380169"
            },

            dialog: {
                title: "求人応募",
                form: {
                    name: "名前",
                    phone: "電話番号",
                    email: "メールアドレス",
                    resume: "履歴書",
                    namePlaceholder: "名前を入力してください",
                    phonePlaceholder: "電話番号を入力してください",
                    emailPlaceholder: "メールアドレスを入力してください",
                    chooseFile: "履歴書ファイルを選択",
                    tip: "PDFまたはWord形式の履歴書をアップロードしてください。ファイルサイズは5MB以下である必要があります。"
                }
            }
        },
        contactPage: {
            navbar: {
                home: 'ホーム',
                contact: 'お問い合わせ'
            },
            header: {
                title: 'お問い合わせ',
                subtitle: 'お気軽にご連絡ください。皆様のご意見をお待ちしております。'
            },
            banner: {
                title: 'コミュニケーションをもっと簡単に',
                desc: 'ご質問・ご提案・ご協力の希望など、いつでもお聞かせください'
            },
            contactInfo: {
                title: '連絡先情報',
                addressTitle: '会社住所',
                address: '中国山東省威海市崮山鎮イノベーションパーク2号館201室',
                phoneTitle: '電話番号',
                faxTitle: 'FAX',
                emailTitle: 'メールアドレス'
            },
            social: {
                title: 'フォローする'
            },
            photos: {
                title: '会社の環境',
                alt: '会社の写真'
            },
            form: {
                title: 'オンラインメッセージ',
                desc: 'ご質問やご提案がございましたら、以下のフォームにご記入ください。できるだけ早くご連絡いたします。'
            },
            faq: {
                title: 'よくある質問',
                desc: 'お客様からよく寄せられる質問とその回答をご紹介します。',
                q1: 'カスタマーサービスに連絡するにはどうすればよいですか？',
                a1: '上記の電話番号やメールアドレス、またはオンラインフォームからご連絡いただけます。24時間以内に対応いたします。',
                q2: '訪問サービスはありますか？',
                a2: 'はい、法人のお客様には訪問による技術サポートやコンサルティングを提供しております。詳細は担当者までご相談ください。',
                q3: '製品デモの申し込み方法は？',
                a3: 'オンラインフォームまたは電話でお申し込みください。専門の担当者が詳しくご案内いたします。',
                q4: 'アフターサービスの内容は？',
                a4: 'すべての製品に1年間の無料サポートと保守を提供します。一部製品は最大3年間延長可能です。緊急時には24時間365日のサポートを提供します。'
            }
        },
        newsPage: {
            header: '企業ニュース',
            subtitle: '和祥泰数码科技有限公司の最新ニュースと業界情報をご覧ください',
            breadcrumb: {
                home: 'ホーム',
                news: '企業ニュース'
            },
            allCategories: 'すべてのカテゴリ',
            categories: {
                company: '会社ニュース',
                industry: '業界動向',
                tech: '技術インサイト'
            },
            uncategorized: '未分類',
            fallbackMessage: 'サーバーが一時的に利用できません。予備データを表示中です。',
            fallbackMessageAlt: 'サーバーに接続できません。予備データを表示中です。',
            noNews: '関連ニュースはありません',
            fallback: {
                news1: {
                    title: '和祥泰数码科技有限公司がシリーズB資金調達に成功、評価額10億元',
                    content: '...'
                },
                news2: {
                    title: '2023年デジタル変革サミットが成功裡に開催、和祥泰が実践を共有',
                    content: '...'
                }
            }
        },
        boxDetailPage: {
            header: "事業領域",
            subtitle: "和祥泰デジタルテクノロジー株式会社の専門的なソリューション",
            breadcrumb: {
                home: "ホーム",
                business: "事業領域"
            },
            current: "事業詳細",
            share: "シェアする：",
            related: "関連事業",
            contact: {
                title: "お問い合わせ",
                phone: "電話番号",
                email: "メール",
                address: "住所",
                btn: "今すぐ相談"
            }
        }


    },

    ko: {
        contact: {
            title: '문의하기',
            description: '질문이나 요청 사항이 있으시면 아래 양식을 통해 문의해 주세요. 최대한 빨리 답변 드리겠습니다.',
            nameLabel: '성명',
            namePlaceholder: '성명을 입력해 주세요',
            emailLabel: '이메일',
            emailPlaceholder: '이메일을 입력해 주세요',
            phoneLabel: '전화번호',
            phonePlaceholder: '전화번호를 입력해 주세요',
            subjectLabel: '주제',
            subjectPlaceholder: '문의 주제를 선택해 주세요',
            subjectOptions: {
                product: '제품 문의',
                techSupport: '기술 지원',
                cooperation: '협력 상담',
                complaint: '불만 및 제안',
                other: '기타'
            },
            messageLabel: '메시지',
            messagePlaceholder: '요청 사항이나 문제를 자세히 작성해 주세요. 최대한 빨리 답변 드리겠습니다.',
            submitButton: '메시지 제출',
            dialogConfirm: '확인'
        },
        validation: {
            nameRequired: '성명을 입력해 주세요',
            nameLength: '성명은 2~20자 사이여야 합니다',
            emailRequired: '이메일을 입력해 주세요',
            emailInvalid: '유효한 이메일 주소를 입력해 주세요',
            phoneRequired: '전화번호를 입력해 주세요',
            phoneInvalid: '유효한 전화번호를 입력해 주세요',
            subjectRequired: '문의 주제를 선택해 주세요',
            messageRequired: '메시지를 입력해 주세요',
            messageLength: '메시지는 10~500자 사이여야 합니다'
        },
        dialog: {
            successTitle: '제출 성공',
            successMessage: '메시지를 보내주셔서 감사합니다. 곧 연락 드리겠습니다!',
            failTitle: '제출 실패',
            failMessage: '죄송합니다. 제출에 실패했습니다. 나중에 다시 시도하시거나 직접 문의해 주세요.'
        },
        navbar: {
            companyName: '상화타이 디지털 테크놀로지 유한회사',
            home: '홈',
            about: '회사 소개',
            aboutCompany: '회사 개요',
            aboutHistory: '연혁',
            aboutTeam: '경영진',
            aboutOrg: '조직도',
            news: '뉴스',
            newsInfo: '뉴스 정보',
            boxs: '사업 분야',
            boxsOverview: '개요',
            boxsServices: '서비스',
            boxsProjects: '프로젝트',
            recruits: '채용',
            touch: '문의하기',
            login: '로그인',
            searchPlaceholder: '검색',
            language: '언어',
            languageNames: {
                zh: '中文',
                en: 'English',
                ja: '日本語',
                ko: '한국어',
            }
        },
        home: {
            statistics: {
                clientCount: "고객 수",
                projectCount: "프로젝트 수",
                teamCount: "팀 인원",
                satisfaction: "고객 만족도"
            },
            slides: [
                {
                    title: '더 나은 삶을 위해',
                    subtitle: '새로운 가치를 창출하다',
                    button: '자세히 보기',
                    buttonLink: '/about',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: '디지털 혁신 촉진',
                    subtitle: '기술이 미래를 만든다',
                    button: '사업 보기',
                    buttonLink: '/boxs',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                },
                {
                    title: '더 나은 미래 함께 만들기',
                    subtitle: '지속 가능한 미래',
                    button: '참여하기',
                    buttonLink: '/recruits',
                    image: '@/assets/images/banner/陌上菜园网站img1.png'
                }
            ],
            business: [
                {
                    title: '전자 테이프 시리즈',
                    desc: '검정/투명 단면·양면 테이프',
                    icon: 'el-icon-s-opportunity',
                    link: '/boxs/software'
                },
                {
                    title: '보호 필름 시리즈',
                    desc: '실리콘·아크릴·정전기 방지 필름',
                    icon: 'el-icon-s-cooperation',
                    link: '/boxs/integration'
                },
                {
                    title: '이형 필름 시리즈',
                    desc: 'PET, PE, PP, 무광, 진주 필름',
                    icon: 'el-icon-s-management',
                    link: '/boxs/consulting'
                },
                {
                    title: '문의하기',
                    desc: '디지털 인쇄 자재 전문 제조업체',
                    icon: 'el-icon-s-platform',
                    link: '/boxs/solutions'
                }
            ],
            newsTitle: '최근 소식',
            moreNews: '더 보기',
            companyVideoTitle: '상화타이 디지털 테크놀로지',
            companyVideoDesc: '2017년, 웨이하이 허샹타이 디지털 기술 유한회사는 중화인민공화국 상무부의 승인을 받아 해외 투자 기업으로 지정되었으며, 같은 해 5월 7일 한국에 하오홍 주식회사 공공 해외창고를 설립하였습니다. 하오홍 주식회사는 경기도 화성시에 위치하고 있으며, 평택항에서 약 30km, 인천항에서 약 40km, 서울공항에서는 약 50~60km 거리에 있어 교통이 편리합니다.',
            learnMore: '자세히 보기',
            joinUsTitle: '상화타이에 참여',
            joinUsSub: '미래를 만나고 나를 발견하다',
            joinUsDesc: '능력 중심의 인재 전략으로 성장의 기회를 제공합니다.',
            joinUsButton: '참여하기',
            statisticsTitle: '기업 성과',
            statisticsDesc: '업계 선두를 목표로 하는 우리 회사의 주요 성과입니다.'
        },
        footer: {
            about: {
                title: "화샹타이 소개",
                companyIntro: "회사 소개",
                history: "발전 역사",
                team: "경영진",
                organization: "조직 구조",
                honors: "기업 명예"
            },
            business: {
                title: "주요 사업",
                overview: "사업 개요",
                softwareDev: "소프트웨어 개발",
                systemIntegration: "시스템 통합",
                techConsulting: "기술 컨설팅",
                projects: "대표 프로젝트"
            },
            news: {
                title: "기업 동향",
                newsInfo: "뉴스 정보",
                mediaReports: "미디어 보도",
                videoCenter: "비디오 센터",
                socialResponsibility: "사회적 책임"
            },
            recruit: {
                title: "채용 정보",
                positions: "채용 공고",
                campus: "신입 채용",
                social: "경력 채용",
                intern: "인턴 채용"
            },
            contact: {
                title: "문의하기",
                address: "주소: 위해 구산진 혁신 창업 산업단지 2호동 201호",
                phone: "전화: 0631-5380169",
                fax: "팩스: 0631-5380166",
                email: "이메일: 18663127999@163.com",
                wechat: "위챗 공식 계정 팔로우"
            },
            company: {
                name: "화샹타이 디지털 기술 유한회사",
                slogan: "스프레이 페인팅 및 사진 재료 전문 생산 기업"
            },
            stock: {
                title: "증권 정보",
                code: "주식 코드",
                time: "마감 시간"
            },
            copyright: {
                rights: "판권 소유",
                icp: "ICP 번호",
                police: "공안 등록 번호"
            },
            nav: {
                privacy: "개인정보 보호정책",
                terms: "서비스 약관",
                sitemap: "사이트맵",
                contact: "문의하기"
            }
        },
        about: {
            companyOverview: '회사 개요',
            companyOverviewEn: 'Company profile',
            companyDesc: '당사는 아름다운 해안 도시인 중국 산둥성 웨이하이에 위치해 있으며, 삼면이 바다로 둘러싸여 있고 해상 교통이 매우 편리합니다. 웨이하이 컨테이너 부두에서 차로 단 5분 거리이며, 부지 면적은 200무 이상입니다. 수년간 인쇄 사진 재료 생산에 종사해온 생산 및 관리 팀을 보유하고 있으며, RC 감광 필름 및 광학 필름을 포함한 다양한 제품을 일류 설비와 공장에서 생산하고 있습니다. 품질을 생명선으로 여기는 경영 이념 아래 엄격한 관리를 실시하고 있으며, 최고 품질의 제품을 한국, 일본, 미국, 호주, 뉴질랜드, 멕시코, 동남아, 유럽 등으로 수출하고 있습니다.',
            environmentTitle: '회사 환경',
            environmentSubtitle: 'Company environment',
            companyIntroTitle: '회사 소개',
            companyIntroDesc: '화샹타이 디지털 테크놀로지 유한회사의 기업 문화와 발전 과정을 소개합니다.',
            videoNotSupported: '이 브라우저는 비디오 재생을 지원하지 않습니다.',
            teamTitle: '핵심 팀',
            teamDesc: '화샹타이 디지털 테크놀로지 유한회사는 열정적이고 전문적인 정예 팀을 보유하고 있습니다.'
        },
        breadcrumb: {
            home: "홈",
            about: "회사 소개",
        },
        historyPage: {
            header: '회사 연혁',
            sectionTitle: '성장의 여정',
            sectionDesc: '창립 이래 지속적인 혁신과 발전을 통해 고객에게 더 나은 서비스와 제품을 제공하며, 회사의 성장과 변화를 함께해 왔습니다.',
            breadcrumb: {
                home: '홈',
                about: '회사 소개',
                history: '회사 연혁'
            },
            timeline: {
                founded: {
                    title: '회사 설립',
                    time: '2010년',
                    content: '베이징에서 공식 설립. 초기 팀은 5명으로 구성되어 기업 서비스용 소프트웨어 개발에 집중.'
                },
                productLaunch: {
                    title: '첫 제품 출시',
                    time: '2012년',
                    content: '첫 기업 관리 소프트웨어를 성공적으로 개발 및 출시, 시장에서 긍정적인 반응을 얻음.'
                },
                seriesA: {
                    title: '시리즈 A 투자 유치',
                    time: '2014년',
                    content: '1,000만 위안 규모의 시리즈 A 투자 유치 완료, 제품 개발 및 시장 확장을 가속화.'
                },
                expansion: {
                    title: '사업 확장',
                    time: '2016년',
                    content: '소프트웨어 개발에서 클라우드 서비스로 영역 확장, 상하이와 선전에 지사 설립.'
                },
                global: {
                    title: '글로벌 진출',
                    time: '2018년',
                    content: '국제 시장 진출, 싱가포르에 아시아 태평양 본부 설립.'
                },
                leading: {
                    title: '업계 선도',
                    time: '2020년',
                    content: '업계 선도 기업으로 성장, 5,000개 이상의 고객사에 서비스 제공, 직원 수 300명 돌파.'
                },
                digital: {
                    title: '디지털 전환',
                    time: '2022년',
                    content: '새로운 디지털 전환 솔루션 출시, 기업의 스마트 업그레이드를 지원.'
                },
                future: {
                    title: '미래를 향해',
                    time: '현재',
                    content: '지속적인 혁신을 통해 글로벌 선도 기업 서비스 제공업체를 목표로 함.'
                }
            },
            stats: {
                clients: '고객 기업 수',
                awards: '업계 수상',
                branches: '글로벌 지사',
                patents: '특허 기술'
            },
            galleryTitle: '성장 갤러리',
            galleryCaptions: {
                0: '창립 초기 모습',
                1: '창립 초기 모습',
                2: '창립 초기 모습',
                3: '창립 초기 모습',
                4: '창립 초기 모습',
                5: '제품 발표회'
            }
        },
        teamPage: {
            title: '팀 소개',
            breadcrumb: {
                home: '홈',
                about: '회사 소개',
                team: '팀 소개'
            },
            sectionTitle: '우리의 경영진 팀',
            sectionDesc: '우리 팀은 업계 전문가로 구성되어 있으며, 풍부한 경험과 혁신 정신을 가지고 고객에게 최고의 제품과 서비스를 제공합니다.',
            loading: '팀 멤버 데이터를 불러오는 중...',
            noData: '팀 멤버 정보가 없습니다',
            departmentTitle: '우리의 전문 팀',
            departmentDesc: '각 부서는 뛰어난 인재들로 구성되어 기업 발전에 강력한 지원을 제공합니다.',
            teamCount: '팀 인원 수',
            projectCount: '완료된 프로젝트',
            coreMembers: '핵심 멤버',
            cultureTitle: '기업 문화 및 가치관',
            joinUsTitle: '우리 팀에 합류하세요',
            joinUsDesc: '우리는 항상 우수한 인재를 찾고 있으며, 함께 더 나은 미래를 만들어가고자 합니다.',
            joinUsButton: '채용 공고 보기',
            departments: {
                research: {
                    name: '연구개발부',
                    desc: '제품 연구 개발과 기술 혁신을 담당하며, 고품질의 제품과 서비스를 만드는 데 힘씁니다.'
                },
                marketing: {
                    name: '마케팅부',
                    desc: '마케팅 홍보와 브랜드 구축을 담당하며, 효과적인 마케팅 전략을 수립하여 브랜드 영향력을 높입니다.'
                },
                product: {
                    name: '제품부',
                    desc: '제품 디자인과 사용자 경험 최적화에 집중하며, 사용자 요구를 깊이 이해하여 뛰어난 제품을 만듭니다.'
                }
            },
            values: {
                innovation: '혁신',
                innovationDesc: '새로운 기술과 방법을 지속적으로 탐구하며 산업 발전을 이끕니다.',
                excellence: '우수성',
                excellenceDesc: '우수한 품질을 추구하고 지속적으로 개선하여 고객에게 최대 가치를 제공합니다.',
                collaboration: '협력',
                collaborationDesc: '팀워크와 공동 성장을 통해 집단 지혜를 극대화합니다.',
                integrity: '성실',
                integrityDesc: '정직하고 신뢰할 수 있으며, 고객과 파트너의 신뢰를 얻고 있습니다.'
            }
        },
        organizationPage: {
            title: '조직 구조',
            breadcrumb: {
                home: '홈',
                about: '회사 소개',
                organization: '조직 구조'
            },
            sectionTitle: '기업 조직 구조',
            sectionDesc: '효율적인 운영을 보장하고 최고의 제품과 서비스를 제공하기 위해 완벽한 조직 관리 시스템을 갖추고 있습니다.',
            loading: '조직 데이터 불러오는 중...',
            noData: '조직 데이터가 없습니다',
            departmentMembersTitle: '부서 구성원',
            departmentResponsibilitiesTitle: '부서 역할 설명',
            departments: {
                presidentOffice: '총재실',
                management: '경영진',
                technology: '기술 부서',
                marketing: '마케팅 부서',
                finance: '재무 부서',
                hr: '인사 부서',
                legal: '법무 부서'
            },
            responsibilities: {
                presidentOffice: [
                    '회사 전략 계획, 업무 조정, 자원 배분, 의사 결정 실행을 담당하며, 회사의 핵심 관리 기관입니다.',
                    '회사 발전 전략 수립 및 실행',
                    '각 부서 업무 조정 및 운영 효율성 향상',
                    '기업 문화 구축 및 기업 이미지 유지',
                    '업무 실행 상황 감독 및 평가'
                ],
                management: [
                    '회사의 핵심 의사 결정 층으로서 전체 전략 방향과 주요 결정을 담당합니다.',
                    '회사 발전 전략 및 연간 목표 수립',
                    '회사 전체 운영 상태 감독',
                    '중대한 결정 및 투자 계획 승인',
                    '각 부서 업무 조정 총괄'
                ],
                technology: [
                    '제품 기술 연구개발, 아키텍처 설계, 기술 혁신을 담당하며 기업 핵심 경쟁력의 중요한 부분입니다.',
                    '기술 아키텍처 설계 및 구현',
                    '제품 개발 및 유지보수',
                    '기술 혁신 및 연구',
                    '기술 문서 작성 및 관리',
                    '기술 지원 및 문제 해결'
                ],
                marketing: [
                    '시장 조사, 브랜드 홍보, 판매 전략, 고객 개발을 담당하며 시장 점유율을 확대합니다.',
                    '시장 조사 및 분석',
                    '브랜드 구축 및 홍보',
                    '판매 전략 수립 및 실행',
                    '고객 개발 및 유지',
                    '마케팅 이벤트 기획 및 실행'
                ],
                finance: [
                    '재무 관리, 자금 배분, 예산 편성, 비용 통제를 담당하며 기업 재무 건전성을 확보합니다.',
                    '회계 및 재무 관리',
                    '예산 편성 및 실행',
                    '비용 분석 및 통제',
                    '투자 및 자금 조달 관리',
                    '세무 계획 및 관리'
                ],
                hr: [
                    '인재 채용, 교육 및 개발, 성과 관리, 보상 및 복지 등을 담당하며 기업 인재 공급을 지원합니다.',
                    '인재 채용 및 배치',
                    '직원 교육 및 경력 개발 계획',
                    '성과 평가 및 인센티브 체계 구축',
                    '보상 및 복지 관리',
                    '기업 문화 구축 및 직원 관계 관리'
                ],
                legal: [
                    '법률 업무, 계약 관리, 지식 재산권 보호 등을 담당하며 법적 리스크를 줄입니다.',
                    '법률 업무 처리',
                    '계약 검토 및 관리',
                    '지식 재산권 보호',
                    '법적 리스크 예방',
                    '법률 상담 및 지원'
                ]
            }
        },
        common: {
            home: '홈'
        },
        boxsPage: {
            title: '사업 분야',
            subtitle: '화상태 디지털 테크놀로지 주식회사의 전문 솔루션',
            banner: {
                title: '전문 솔루션으로 기업 성장을 지원합니다',
                desc: '화상태 디지털 테크놀로지는 포괄적인 기술 서비스와 솔루션을 제공합니다'
            },
            searchPlaceholder: '사업 분야 키워드 검색',
            searchResultsTitle: '검색 결과',
            noRelatedBusiness: '관련 사업이 없습니다',
            viewDetails: '상세 보기',
            latestRelease: '최신 출시',
            featuredSection: {
                title: '주요 서비스',
                desc: '우리의 핵심 사업 분야'
            },
            categoriesSection: {
                title: '사업 카테고리',
                desc: '필요에 따라 적합한 솔루션을 선택하세요'
            },
            categoryTabs: {
                '1': '기업 서비스',
                '2': '기술 혁신',
                '3': '디지털 인프라',
            },
            otherBusiness: '기타 사업'
        },
        servicesPage: {
            common: {
                home: '홈'
            },
            boxsPage: {
                title: '사업 분야'
            },
            title: '기술 서비스',
            subtitle: '화상태 디지털 테크놀로지 주식회사의 전문 기술 지원',
            ourServices: '우리의 서비스',
            description: '다양한 요구를 충족하는 포괄적인 기술 서비스',
            alertTitle: '이 페이지는 현재 준비 중입니다. 기대해 주세요',
            alertDescription: '기술 서비스 내용을 정리 중이며 곧 제공할 예정입니다'
        },
        projectsPage: {
            commonHome: '홈',
            title: '대표 프로젝트',
            subtitle: '화상태 디지털 기술 유한회사의 성공 사례 전시',
            classicCasesTitle: '클래식 프로젝트 사례',
            classicCasesDesc: '다양한 산업 고객에게 전문 솔루션을 제공합니다.',
            alertTitle: '이 페이지는 현재 준비 중입니다. 기대해 주세요.',
            alertDescription: '우수한 프로젝트 사례를 정리 중이며 곧 공개할 예정입니다.',
            boxsPageTitle: '사업 분야'
        },
        recruitPage: {
            common: {
                cancel: "취소",
                submit: "제출",
                submitSuccess: "지원서가 성공적으로 제출되었습니다. 최대한 빨리 연락드리겠습니다.",
                submitFail: "제출 실패, 나중에 다시 시도해 주세요.",
                fetchFail: "데이터를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
                nameLengthLimit: "이름 길이는 2자에서 20자 사이여야 합니다.",
                invalidPhone: "올바른 전화번호를 입력하세요.",
                invalidEmail: "올바른 이메일 형식을 입력하세요.",
                invalidFileType: "PDF 또는 Word 형식의 이력서만 업로드할 수 있습니다.",
                fileTooLarge: "파일 크기는 5MB를 초과할 수 없습니다.",
                exceedFileLimit: "최대 1개의 파일만 업로드할 수 있습니다.",
                unknown: "알 수 없는 유형",
                noRequirement: "상세한 직무 요구사항이 없습니다."
            },
            title: "함께 하세요",
            subtitle: "와이판테크 디지털 테크놀로지 주식회사와 함께 미래를 만듭니다",
            breadcrumbHome: "홈",
            breadcrumbCurrent: "채용 정보",

            culture: {
                alt: "회사 문화",
                title: "회사 문화",
                description: "와이판테크 디지털 테크놀로지 주식회사에서는 인재를 회사에서 가장 소중한 자산으로 믿습니다...",
                values: [
                    {icon: "el-icon-star-on", title: "혁신", text: "변화를 수용하고, 혁신을 두려워하지 않으며, 기술 발전을 추진합니다"},
                    {icon: "el-icon-s-cooperation", title: "협력", text: "팀워크를 통해 함께 성장하고 윈윈을 실현합니다"},
                    {icon: "el-icon-s-flag", title: "탁월함", text: "탁월함을 추구하고 완벽을 기하며 자신을 초월합니다"},
                    {icon: "el-icon-s-claim", title: "정직", text: "정직하고 신뢰할 수 있으며, 말과 행동이 일치하고 책임감이 있습니다"}
                ]
            },

            category: {
                title: "직무 카테고리",
                description: "당신에게 맞는 경력 경로를 탐색하세요"
            },

            job: {
                loading: "직무 데이터를 불러오는 중...",
                empty: "관련 직무 정보가 없습니다",
                header: "우수 인재를 찾고 업계를 선도하는 제품을 함께 만듭니다",
                requirements: "직무 요구사항",
                salary: "급여 범위",
                apply: "지금 지원하기"
            },

            benefits: {
                title: "우리와 함께 해야 하는 이유",
                description: "경쟁력 있는 급여와 완벽한 복리후생을 제공합니다",
                items: [
                    {icon: "el-icon-medal", title: "경쟁력 있는 급여", text: "업계 내 경쟁력 있는 급여 수준과 성과 보너스를 제공합니다"},
                    {icon: "el-icon-first-aid-kit", title: "사회보험 및 주택기금", text: "완벽한 사회보험과 주택기금을 제공합니다"},
                    {icon: "el-icon-sunrise", title: "유급 휴가", text: "추가 유급 휴가와 탄력 근무제를 누리세요"},
                    {icon: "el-icon-reading", title: "교육 및 성장", text: "전문 기술 교육과 경력 개발 계획을 제공합니다"},
                    {icon: "el-icon-dessert", title: "팀 활동", text: "정기적인 팀 빌딩 활동과 회사 여행을 주최합니다"},
                    {icon: "el-icon-trophy", title: "승진 기회", text: "투명한 승진 메커니즘과 넓은 경력 개발 기회"}
                ]
            },

            process: {
                title: "지원 절차",
                description: "채용 과정을 이해하고 충분히 준비하세요",
                steps: [
                    {title: "이력서 제출", text: "공식 웹사이트나 채용 플랫폼을 통해 이력서를 제출하세요"},
                    {title: "이력서 심사", text: "HR 팀이 요건에 맞는 이력서를 1차 심사합니다"},
                    {title: "기술 면접", text: "기술 팀과 전문 능력 면접을 진행합니다"},
                    {title: "종합 면접", text: "부서 책임자와 심층 면담을 진행합니다"},
                    {title: "채용 통보", text: "채용 통보를 발송하고 입사 세부 사항을 확인합니다"}
                ]
            },

            contact: {
                title: "문의하기",
                description: "채용 관련 질문이 있으시면 언제든지 연락 주세요",
                email: "채용 이메일: hr@yifantech.com",
                emailName: '채용 이메일 ：',
                emailDomain: '18663127999',
                phone: "채용 핫라인: 0631-5380169"
            },

            dialog: {
                title: "직무 지원",
                form: {
                    name: "이름",
                    phone: "전화번호",
                    email: "이메일",
                    resume: "이력서",
                    namePlaceholder: "이름을 입력하세요",
                    phonePlaceholder: "전화번호를 입력하세요",
                    emailPlaceholder: "이메일 주소를 입력하세요",
                    chooseFile: "이력서 파일 선택",
                    tip: "PDF 또는 Word 형식의 이력서를 업로드하세요. 파일 크기는 5MB를 넘지 않아야 합니다."
                }
            }
        },
        contactPage: {
            navbar: {
                home: '홈',
                contact: '문의하기'
            },
            header: {
                title: '문의하기',
                subtitle: '언제든지 연락 주세요. 여러분의 피드백을 기다리고 있습니다.'
            },
            banner: {
                title: '소통을 더 간편하게',
                desc: '질문, 제안 또는 협력 제안이 있으시면 언제든지 환영합니다.'
            },
            contactInfo: {
                title: '연락처 정보',
                addressTitle: '회사 주소',
                address: '중국 산둥성 웨이하이시 구산진 창업산업단지 2호동 201호',
                phoneTitle: '전화번호',
                faxTitle: '팩스',
                emailTitle: '이메일'
            },
            social: {
                title: '팔로우하기'
            },
            photos: {
                title: '회사 환경',
                alt: '회사 사진'
            },
            form: {
                title: '온라인 문의',
                desc: '문의사항이나 제안이 있으시면 아래 양식을 작성해 주세요. 최대한 빠르게 답변드리겠습니다.'
            },
            faq: {
                title: '자주 묻는 질문',
                desc: '자주 문의하시는 질문을 정리해 두었습니다. 도움이 되었으면 좋겠습니다.',
                q1: '고객 서비스 팀에 어떻게 연락하나요?',
                a1: '위의 전화번호나 이메일로 연락하시거나, 온라인 양식을 통해 문의를 남겨주세요. 24시간 이내에 답변드리겠습니다.',
                q2: '방문 서비스를 제공하나요?',
                a2: '네, 기업 고객에게는 기술 지원 및 컨설팅 방문 서비스를 제공합니다. 담당자와 조율해주세요.',
                q3: '제품 시연을 신청하려면?',
                a3: '온라인 양식이나 전화로 신청하시면, 전문 담당자가 시연을 진행해 드립니다.',
                q4: '애프터 서비스 정책은 어떻게 되나요?',
                a4: '모든 제품은 최소 1년의 무상 기술 지원 및 유지보수를 제공하며, 일부 제품은 최대 3년까지 연장 가능합니다. 긴급 상황에는 24시간 지원을 제공합니다.'
            }
        },
        newsPage: {
            header: '기업 뉴스',
            subtitle: '화샹타이 디지털 기술 유한회사의 최신 소식과 업계 동향을 확인하세요',
            breadcrumb: {
                home: '홈',
                news: '기업 뉴스'
            },
            allCategories: '모든 카테고리',
            categories: {
                company: '회사 뉴스',
                industry: '업계 동향',
                tech: '기술 인사이트'
            },
            uncategorized: '미분류',
            fallbackMessage: '서버를 일시적으로 사용할 수 없습니다. 예비 데이터를 표시합니다.',
            fallbackMessageAlt: '서버에 연결할 수 없습니다. 예비 데이터를 표시합니다.',
            noNews: '관련 뉴스가 없습니다',
            fallback: {
                news1: {
                    title: '화샹타이 디지털, 시리즈 B 투자 성공, 기업 가치 10억 위안',
                    content: '...'
                },
                news2: {
                    title: '2023 디지털 전환 서밋 성황리에 개최, 화샹타이가 실천 공유',
                    content: '...'
                }
            }
        },
        boxDetailPage: {
            header: "사업 분야",
            subtitle: "허샹타이 디지털 테크놀로지 주식회사의 전문 솔루션",
            breadcrumb: {
                home: "홈",
                business: "사업 분야"
            },
            current: "사업 상세",
            share: "공유하기:",
            related: "관련 사업",
            contact: {
                title: "문의하기",
                phone: "전화번호",
                email: "이메일",
                address: "주소",
                btn: "지금 상담하기"
            }
        }


    }
};
